import { render, staticRenderFns } from "./AttractivenessForm.vue?vue&type=template&id=4f3b8489&scoped=true"
import script from "./AttractivenessForm.vue?vue&type=script&lang=js"
export * from "./AttractivenessForm.vue?vue&type=script&lang=js"
import style0 from "./AttractivenessForm.vue?vue&type=style&index=0&id=4f3b8489&prod&lang=less"
import style1 from "./AttractivenessForm.vue?vue&type=style&index=1&id=4f3b8489&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b8489",
  null
  
)

export default component.exports